import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const ThankYou = () => {
  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <Row>
        <Col className="d-flex flex-column align-items-center">
          {/* Logo outside the card, centered */}
          <div className="text-center mb-4">
            <img
              src="/logo.jpg" // Accessing from the public folder
              alt="Edufulness Logo"
              style={{ maxWidth: '200px' }}
            />
          </div>
          {/* Card below the logo */}
          <Card className="text-center p-4 shadow-lg" style={{ borderRadius: '15px', backgroundColor: '#f8f9fa', border: 'none' }}>
            <Card.Body>
              <div className="mb-3 d-flex justify-content-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="70"
                  height="70"
                  fill="green"
                  className="bi bi-check-circle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
              </div>
              <Card.Title as="h2" className="mb-3" style={{ color: '#101743', fontSize: '2.2rem', fontWeight: 'bold' }}>Thank You for Registering!</Card.Title>
              <Card.Text style={{ fontSize: '1.3rem' }}>
                Thank you for registering for the upcoming <strong>Masterclass</strong> with <strong>Edufulness</strong>.
              </Card.Text>
              <Card.Text style={{ fontSize: '1.3rem' }}>
                <strong>Please check </strong>
                your email inbox in the <strong>primary/promotions section</strong> for the
                <strong> Class Link</strong>.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ThankYou;